<template>
  <div class="flex h-screen bg-gray-50 dark:bg-gray-900">
    <!-- Sidebar Component -->
    <Sidebar 
      :sidebarOpen="sidebarOpen" 
      :isDark="isDark"
      @toggle-sidebar="toggleSidebar" 
      @toggle-dark-mode="toggleDarkMode" 
    />

    <!-- Main content wrapper - largura se ajusta automaticamente baseado no estado do sidebar -->
    <div class="flex flex-col flex-1 w-full">
      <!-- Botão de toggle sidebar móvel - visível apenas quando o sidebar está fechado em mobile -->
      <div class="lg:hidden p-4" v-if="!sidebarOpen">
        <button
          @click="toggleSidebar"
          class="p-1 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
          aria-label="Toggle Menu"
        >
          <svg
            class="w-6 h-6 text-gray-600 dark:text-gray-300"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h7"
            />
          </svg>
        </button>
      </div>

      <!-- Main content -->
      <main class="h-full overflow-y-auto p-4 bg-gray-50 dark:bg-gray-900">
        <div class="container mx-auto">
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import Sidebar from '../components/Sidebar.vue';

export default {
  name: 'AdminLayout',
  components: {
    Sidebar
  },
  setup() {
    const sidebarOpen = ref(true);
    const isDark = ref(false);

    // Alternar visibilidade do sidebar
    const toggleSidebar = () => {
      console.log('Toggle sidebar called, current state:', sidebarOpen.value);
      sidebarOpen.value = !sidebarOpen.value;
      
      // Salvar preferência do usuário
      localStorage.setItem('sidebarOpen', sidebarOpen.value ? 'true' : 'false');
      
      console.log('New sidebar state:', sidebarOpen.value);
    };

    // Alternar modo escuro
    const toggleDarkMode = () => {
      isDark.value = !isDark.value;
      
      if (isDark.value) {
        document.documentElement.classList.add('dark');
        localStorage.theme = 'dark';
      } else {
        document.documentElement.classList.remove('dark');
        localStorage.theme = 'light';
      }
    };

    // Inicialização
    onMounted(() => {
      console.log('Admin layout mounted');
      
      // Recuperar preferência do sidebar
      const savedSidebarState = localStorage.getItem('sidebarOpen');
      if (savedSidebarState !== null) {
        sidebarOpen.value = savedSidebarState === 'true';
      } else {
        // Se não houver preferência salva, iniciar como aberto em desktop e fechado em mobile
        sidebarOpen.value = window.innerWidth >= 1024;
      }
      
      // Verificar tema escuro
      if (localStorage.theme === 'dark' || 
          (!localStorage.theme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        isDark.value = true;
        document.documentElement.classList.add('dark');
      }
    });

    return {
      sidebarOpen,
      toggleSidebar,
      isDark,
      toggleDarkMode
    };
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>